// extracted by mini-css-extract-plugin
module.exports =  {"promotion-modal":"yiw0IwO","promotionModal":"yiw0IwO","header":"gpAAxbl","title":"cDYgcJZ","avatar":"_rX_I78","subtitle":"IwdKWQg","details":"XUd9a5W","footer":"UAWtEMP"};